<!-- eslint-disable max-len -->
<!-- eslint-disable vue/no-use-v-if-with-v-for -->
<template>
  <div
    class="summaryE4"
  >
    <div class="titleSection">
      {{ $t('massBalance.mainInfo') }}
    </div>
    <VTextField
      :value="e4Config.improvementInitiative.client.name"
      :label="$t('forms.labels.client')"
      outlined
      readonly
    />
    <VTextField
      :value="e4Config.improvementInitiative.site.name"
      :label="$t('forms.labels.site')"
      outlined
      readonly
    />
    <VTextField
      :value="e4Config.improvementInitiative.massBalanceName"
      :label="$t('forms.labels.massBalanceName')"
      outlined
      readonly
    />
    <VTextField
      :value="e4Config.improvementInitiative.projectName"
      :label="$t('forms.labels.projectName')"
      outlined
      readonly
    />
    <VTextarea
      :value="e4Config.improvementInitiative.projectDescription"
      :label="$t('forms.labels.projectDescription')"
      outlined
      readonly
    />
    <v-row>
      <v-col
        cols="12"
        md="6"
      >
        <VTextField
          :value="e4Config.improvementInitiative.waterSavingsUnit"
          :label="$t('massBalance.e4Form.improvementInitiative.waterSavingsUnit')"
          outlined
          readonly
        />
      </v-col>
      <v-col
        cols="12"
        md="6"
      >
        <VTextField
          :value="e4Config.improvementInitiative.energySavingUnit"
          :label="$t('massBalance.e4Form.improvementInitiative.energySavingUnit')"
          outlined
          readonly
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col
        cols="12"
        md="6"
      >
        <VTextField
          :value="e4Config.improvementInitiative.co2EmissionsUnit"
          :label="$t('massBalance.e4Form.improvementInitiative.co2EmissionsUnit')"
          outlined
          readonly
        />
      </v-col>
    </v-row>

    <div class="lign" />

    <!-- -------------------------------------------------------- -->

    <div class="titleSection">
      {{ $t('massBalance.periodicityConsumption') }}
    </div>

    <VTextField
      :value="getPeriodName(e4Config.baselineData.reportingPeriod)"
      :label="$t('massBalance.reportingPeriod')"
      outlined
      readonly
    />

    <div class="lign" />

    <v-container
      style="padding: 0px;"
      fluid
      fillWidth
    >
      <v-table
        height="300px"
        fixedHeader
        bordered
        density="compact"

        style="margin: none; padding: 0 !important; border-collapse: collapse;"
      >
        <thead>
          <tr
            style="background-color:#26384B; color: white; height: 40px;"
          >
            <th
              width="150"
              style="font-weight: 400; text-align: left; padding-left: 10px; border-right: 1px solid white;"
            >
              {{ $t('massBalance.savings') }}
            </th>
            <th
              width="150"
              style="font-weight: 400;border-right: 1px solid white;"
            >
              {{ $t('massBalance.e4Form.baselineData.columnTitles.waterSavingsBaseline') }}
            </th>
            <th
              width="150"
              style="font-weight: 400; border-right: 1px solid white;"
            >
              {{ $t('massBalance.e4Form.baselineData.columnTitles.steamProductionBaseline') }}
            </th>
            <!-- La dernière colonne est subdivisée dynamiquement -->
            <th
              v-if="e4Config.boilerOperatingParameters.energyBalanceType === E4_FUEL"
              width="600"
              :colspan="e4Config.boilerOperatingParameters.fuels.length"
              style="font-weight: 400;"
            >
              {{ $t('massBalance.e4Form.baselineData.columnTitles.energySavingsBaseline') }}
            </th>
          </tr>
        </thead>
        <tbody
          style="max-height: 50px !important; color: #26384B; font-weight: 400;"
        >
          <tr
            v-if="e4Config.boilerOperatingParameters.energyBalanceType === E4_FUEL"
          >
            <td
              style="font-weight: 400; text-align: left; padding-left: 10px; border: 1px solid black;"
            />
            <td
              style="font-weight: 400; border: 1px solid black;"
            />
            <td
              style="font-weight: 400; border: 1px solid black;"
            />
            <td
              v-for="(combustible, index) in e4Config.boilerOperatingParameters.fuels"
              v-if="e4Config.boilerOperatingParameters.energyBalanceType === E4_FUEL"
              :key="index"
              :style="`font-weight: 400; border: 1px solid black;width: ${600 / e4Config.boilerOperatingParameters.fuels.length}px`"
            >
              {{ $t('massBalance.combustible') }} {{ index + 1 }} : {{ combustible.fuelName }}
            </td>
          </tr>

          <tr>
            <td
              style="font-weight: 400; text-align: left; padding-left: 10px; border: 1px solid black; height: 100px;"
            >
              {{ $t('massBalance.reportUnit') }}
            </td>
            <td
              style="font-weight: 400;"
            >
              <VSelect
                v-model="e4Config.baselineData.waterSavingReport.unit"
                :items="waterSavingReportUnits"
                dense
                label=""
                readonly
              />
            </td>

            <td
              style="font-weight: 400; border: 1px solid black;"
            >
              <VSelect
                v-model="e4Config.baselineData.steamProductionReport.unit"
                :items="co2EmissionsReportUnits"
                dense
                label=" "
                readonly
              />
            </td>
            <td
              v-for="(combustible, index) in e4Config.boilerOperatingParameters.fuels"
              v-if="e4Config.boilerOperatingParameters.energyBalanceType === E4_FUEL"
              :key="index"
              style="font-weight: 400; border: 1px solid black;"
            >
              <VTextField
                v-model="e4Config.boilerOperatingParameters.fuels[index].unit"
                class="centerText"
                readonly
                @change="onInput"
              />
            </td>
          </tr>
          <tr
            v-for="(period, index) in e4Config.baselineData.periods"
            :key="period"
          >
            <td
              v-if="e4Config.baselineData.reportingPeriod !== 'annual'"
              style="font-weight: 400; text-align: left; padding-left: 10px; border: 1px solid black;"
            >
              {{ capitalizeFirstLetter($t(`massBalance.e4Form.months.${e4Config.baselineData.periods[index].startMonth}`)) }}
              {{ e4Config.baselineData.reportingPeriod !== 'monthly' && e4Config.baselineData.reportingPeriod !== 'annual' ? ' - ' : '' }}
              {{ e4Config.baselineData.reportingPeriod === 'monthly' ? '' : capitalizeFirstLetter($t(`massBalance.e4Form.months.${e4Config.baselineData.periods[index].endMonth}`)) }}
            </td>
            <td
              style="font-weight: 400; text-align: left; padding-left: 10px; border: 1px solid black;"
            >
              <VTextField
                v-model.number="e4Config.baselineData.startDate"
                :outlined="false"
                class="centerText"
                readonly
                @change="onInput"
              />
            </td>


            <td
              style="font-weight: 400; border: 1px solid black;"
            >
              <VTextField
                v-model.number="e4Config.baselineData.waterSavingReport.value[index]"
                :outlined="false"
                class="centerText"
                readonly
                type="number"
                @change="onInput"
              />
            </td>
            <td
              style="font-weight: 400; border: 1px solid black;"
            >
              <VTextField
                v-model.number="e4Config.baselineData.steamProductionReport.value[index]"
                :outlined="false"
                class="centerText"
                readonly
                type="number"
                @change="onInput"
              />
            </td>
            <td
              v-for="(combustible, indexCombustible) in e4Config.boilerOperatingParameters.fuels"
              v-if="e4Config.boilerOperatingParameters.energyBalanceType === E4_FUEL"

              :key="indexCombustible"
              style="font-weight: 400; border: 1px solid black;"
            >
              <VTextField
                v-model.number="e4Config.boilerOperatingParameters.fuels[indexCombustible].fuelConsumption[index]"
                class="centerText"
                readonly
                @change="onInput"
              />
            </td>
          </tr>
        </tbody>
      </v-table>
    </v-container>

    <div
      v-if="e4Config.boilerOperatingParameters.energyBalanceType === E4_BOILER"
      class="baseline__titleSection"
    >
      <img
        :src="cloudSVG"
        alt="Icon"
        width="20px"
        height="20px"
      >
      <div>
        {{ $t('massBalance.energySavingsBaseline') }}
      </div>
    </div>

    <div
      v-if="e4Config.boilerOperatingParameters.energyBalanceType === E4_BOILER"
    >
      <v-row>
        <v-col
          cols="12"
          md="6"
        >
          <VTextField
            v-model.number="e4Config.baselineData.boilerConsumption.averageBoilerEfficiencyPercentage"
            :label="$t('massBalance.averageBoilerEfficiencyPercentage')"
            outlined
            dense
            class="centerText"
            readonly
            @change="onInput"
          />
        </v-col>
        <v-col
          cols="12"
          md="6"
        >
          <VTextField
            v-model.number="e4Config.baselineData.boilerConsumption.estimatedBoilerEfficiencyPercentage"
            :label="$t('massBalance.estimatedBoilerEfficiency')"
            outlined
            dense
            class="centerText"
            readonly
          />
        </v-col>
      </v-row>
    </div>
  </div>
</template>

<script>
import VTextField from '@/components/shared/widgets/forms/VuetifyInputs/VTextField.vue';
import VSelect from '@/components/shared/widgets/forms/VuetifyInputs/VSelect.vue';

import { mapGetters } from 'vuex';
import { map } from 'lodash';
import {
    WATER_SAVINGS_UNITS,
    CO2_EMISSIONS_UNITS,
    E4_FUEL,
    E4_BOILER,
} from '@/aquassist-shared/constants/massBalance';

import cloudSVG from '@/assets/images/cloud_black.svg';

export default {
    name: 'Summary',

    components: {
        VTextField,
        VSelect,
    },

    data() {
        return {
            months: ['january', 'february', 'march', 'april', 'may', 'june', 'july', 'august', 'september', 'october', 'november', 'december'],
            quantityOfPeriods: {
                annual: 1,
                semiannual: 2,
                quarterly: 4,
                monthly: 12,
            },
        };
    },

    computed: {
        ...mapGetters([
            'e4Config',
        ]),
        E4_FUEL() {
            return E4_FUEL;
        },
        E4_BOILER() {
            return E4_BOILER;
        },
        waterSavingReportUnits() {
            return map(WATER_SAVINGS_UNITS, value => ({ id: value, name: this.$t(`massBalance.e4Form.units.${value}`) }));
        },
        co2EmissionsReportUnits() {
            return map(CO2_EMISSIONS_UNITS, value => ({ id: value, name: this.$t(`massBalance.e4Form.units.${value}`) }));
        },
        cloudSVG() {
            return cloudSVG;
        },
    },

    methods: {
        getMonthAfter(month, decallageNumber) {
            const index = this.months.indexOf(month);
            if (index === -1) {
                throw new Error(`Le mois ${month} n'existe pas dans la liste.`);
            }
            const sixMonthsLaterIndex = (index + decallageNumber) % 12;
            return this.months[sixMonthsLaterIndex];
        },
        getMonthPairs() {
            const pairs = [];
            const totalMonths = this.months.length;

            // Regroupe les mois par paires
            for (let i = 0; i < totalMonths; i += 2) {
                pairs.push([i, i + 1].filter(index => index < totalMonths)); // Évite les index hors limite
            }
            return pairs;
        },
        getPeriodName(periodicity) {
            return this.$t(`massBalance.e4Form.periodicities.${periodicity}`) || 'error';
        },
        capitalizeFirstLetter(string) {
            return string.charAt(0).toUpperCase() + string.slice(1);
        },
    },
};

</script>

<style lang="scss">

.summaryE4 {
  .centerText input {
    text-align: center !important;
  }
}
</style>

<style lang="scss">

.summaryE4 {
  .centerText input {
    text-align: center !important;
  }
}
</style>

<style scoped lang="scss">

.summaryE4 {
  .centerText input {
    text-align: center !important;
  }
}
</style>

<style scoped lang="scss">

.lign{
  height: 3px;
  width: 100%;
  background-color: #26384B;
  margin-bottom: 25px;
  margin-bottom: 25px;
  margin-top: 25px;
}

.smallLign{
  height: 1px;
  width: 100%;
  background-color: #26384B;
  margin-bottom: 25px;
  margin-bottom: 25px;
  margin-top: 25px;
}

.titleSection {
  margin: 0px !important;
  padding : 0 !important;
  color: #26384B;
  font-weight: bold;
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;

  display: flex;
  flex-direction: row;
  align-items: center;

  margin-bottom: 20px !important;
  margin-top: 10px !important;

  p {
    margin: 0px
  }
}

</style>
